"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M21.518 1.19a2.453 2.453 0 0 1 2.477 2.316l.005.166v15.625a3.519 3.519 0 0 1-3.322 3.508l-.192.006H3.672c-1.993 0-3.567-1.478-3.667-3.4L0 19.215V12a.5.5 0 0 1 .41-.491L.5 11.5h5.845V3.671a2.454 2.454 0 0 1 2.317-2.477l.166-.005h12.69Zm0 1H8.828c-.783 0-1.406.576-1.476 1.337l-.007.145v15.465c0 .988-.37 1.873-.984 2.527l-.146.146h14.271a2.518 2.518 0 0 0 2.509-2.348l.005-.165V3.672c0-.831-.651-1.482-1.482-1.482ZM6.345 12.5H1v6.716c0 1.454 1.174 2.595 2.672 2.595 1.609 0 2.595-1.258 2.669-2.522l.004-.152V12.5Zm9.858 5.344a.5.5 0 0 1 .09.992l-.09.008h-6.186a.5.5 0 0 1-.09-.992l.09-.008h6.186Zm4.124 0a.5.5 0 0 1 .09.992l-.09.008H17.87a.5.5 0 0 1-.09-.992l.09-.008h2.458Zm-4.124-3.172a.5.5 0 0 1 .09.992l-.09.008h-6.186a.5.5 0 0 1-.09-.991l.09-.008h6.186Zm4.124 0a.5.5 0 0 1 .09.992l-.09.008H17.87a.5.5 0 0 1-.09-.991l.09-.008h2.458ZM16.203 11.5a.5.5 0 0 1 .09.992l-.09.008h-6.186a.5.5 0 0 1-.09-.992l.09-.008h6.186Zm4.124 0a.5.5 0 0 1 .09.992l-.09.008H17.87a.5.5 0 0 1-.09-.992l.09-.008h2.458Zm0-7.138c.246 0 .45.176.492.41l.008.09v3.965a.5.5 0 0 1-.41.492l-.09.008h-10.31a.5.5 0 0 1-.492-.41l-.008-.09V4.862a.5.5 0 0 1 .41-.492l.09-.008h10.31Zm-.5 1h-9.31v2.965h9.31V5.362Z",
    clipRule: "evenodd"
  })]
});